import React, { useState } from "react";
import bluelogo from "../images/EM-LOGO_Blue.png";
import "../CSS/designCompetition.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BikeDesignCompRegisteScreen = () => {
  const [name, setName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [college, setCollege] = useState("");
  const [course, setCourse] = useState("");
  const [location, setLocation] = useState("");
  const [medium, setMedium] = useState("");
  const navigate = useNavigate();
  const register = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        name,
        birthDate, // if you're using it, otherwise remove
        gender,
        email,
        phoneNumber,
        college,
        course,
        location,
        medium,
      };

      const { data } = await axios.post("/api/form/register", payload);

      // ✅ Success notification
      navigate("/watt-a-design/thank-you");
      console.log("Server response:", data);
    } catch (error) {
      console.error("Error during registration:", error);

      if (error.response) {
        console.error(error.response.data.message || "Something went wrong");
      } else {
        console.error("Server not reachable");
      }
    }
  };

  return (
    <div>
      <div className="factory-schedule-booking bike-design-reg">
        <div className="d-flex justify-content-center my-4 mb-lg-5">
          <img
            src={bluelogo}
            className="img-fluid"
            style={{ width: "150px" }}
            alt=""
          />
        </div>
        <>
          <div className="booking-div mx-lg-auto mx-3 my-5">
            <div className="left-section d-none d-lg-block">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/designCompetition/RegisterWebBreaker.jpg"
                className="img-fluid"
              ></img>
            </div>
            <div className="right-section p-lg-4 p-3">
              <h2 className="metropolis-bold text-center">Fill in details</h2>
              <div
                className="py-3 px-lg-3 d-flex justify-content-center"
                onSubmit={register}
              >
                <form className="col-md-6" style={{ fontSize: "0.9em" }}>
                  <div className="mb-4">
                    <div className="field-wrapper">
                      <input
                        type="text"
                        name="Full Name"
                        value={name}
                        required
                        autoComplete="new-password"
                        onChange={(e) => setName(e.target.value)}
                        className={`${name.length > 0 && "bg-white"} rounded-2`}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>Full Name*</span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="date"
                        name="Birth Date"
                        value={birthDate}
                        required
                        autoComplete="new-password"
                        onChange={(e) => setBirthDate(e.target.value)}
                        className={`${
                          birthDate.length > 0 && "bg-white"
                        } rounded-2 `}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>Date of Birth*</span>
                      </div>
                    </div>
                  </div> */}
                  <div className="mb-4 ">
                    <select
                      name="gender"
                      required
                      autoComplete="new-password"
                      className={`rounded-2 form-select`}
                      style={{
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        padding: "10px",
                        paddingLeft: "20px",
                        border: "1px solid #b1b3b6",
                      }}
                      id=""
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value="" defaultValue disabled>
                        Select Gender*
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Transgender">Transgender</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="email"
                        name="email"
                        value={email}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                        className={`${
                          email.length > 0 && "bg-white"
                        } rounded-2`}
                        autoComplete="new-password"
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>Email*</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="tel"
                        name="phone number"
                        value={phoneNumber}
                        required
                        onChange={(e) => {
                          const mobileNumber = e.target.value.slice(0, 12);
                          setPhoneNumber(mobileNumber);

                          if (/^[6-9]\d{9}$/.test(mobileNumber)) {
                            e.target.setCustomValidity("");
                          } else {
                            e.target.setCustomValidity(
                              "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                            );
                          }
                        }}
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                          )
                        }
                        autoComplete="new-password"
                        className={`${
                          phoneNumber.length > 0 && "bg-white"
                        } rounded-2`}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>Phone Number*</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="text"
                        name="College Name"
                        value={college}
                        required
                        autoComplete="new-password"
                        onChange={(e) => setCollege(e.target.value)}
                        className={`${
                          college.length > 0 && "bg-white"
                        } rounded-2`}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>College/Organisation Name*</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="text"
                        name="Course"
                        value={course}
                        required
                        autoComplete="new-password"
                        onChange={(e) => setCourse(e.target.value)}
                        className={`${
                          course.length > 0 && "bg-white"
                        } rounded-2`}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>Course*</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 ">
                    <div className="field-wrapper">
                      <input
                        type="text"
                        name="Location"
                        value={location}
                        required
                        autoComplete="new-password"
                        onChange={(e) => setLocation(e.target.value)}
                        className={`${
                          location.length > 0 && "bg-white"
                        } rounded-2`}
                        style={{
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                        }}
                        id=""
                      />
                      <div className="field-placeholder">
                        <span>City & State*</span>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4 ">
                    <select
                      name="medium"
                      required
                      autoComplete="new-password"
                      className={`rounded-2 form-select`}
                      style={{
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        padding: "10px",
                        paddingLeft: "20px",
                        border: "1px solid #b1b3b6",
                      }}
                      id=""
                      value={medium}
                      onChange={(e) => setMedium(e.target.value)}
                    >
                      <option value="" defaultValue disabled>
                        How did you hear about us*
                      </option>
                      <option value="LinkedIn">LinkedIn</option>
                      <option value="Friends">Friends</option>
                      <option value="Family">Family</option>
                      <option value="Ads">Advertisements</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="my-4">
                    <small className="text-muted">
                      By submitting you agree to our Terms & Conditions and
                      Privacy Policy
                    </small>
                    <br />
                    <button
                      type="submit"
                      class="btn btn-outline-primary w-100 rounded-5 mt-3"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default BikeDesignCompRegisteScreen;
